export const state = {
  notifications: [],
}

export const getters = {
  allNotifications: (state) => state.notifications,
}

export const mutations = {
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications
  },
  ADD_NOTIFICATION(state, notification) {
    state.notifications.unshift(notification)
  },
  REMOVE_NOTIFICATION(state, notification) {
    state.notifications = state.notifications.filter((notif) => {
      return notif.id !== notification.id
    })
  },
  REMOVE_NOTIFICATIONS(state) {
    state.notifications = []
  },
}

export const actions = {
  getNotfications({ commit }) {
    // commit('SET_NOTIFICATIONS');
  },

  addNotification({ commit }, notification) {
    commit('ADD_NOTIFICATION', notification)
  },
  removeNotification({ commit }, notification) {
    commit('REMOVE_NOTIFICATION', notification)
  },

  removeNotifications({ commit }) {
    commit('REMOVE_NOTIFICATIONS')
  },
}
